module.exports = __webpack_public_path__ + "static/media/logo-mesa-de-trabajo-1-copia@3x.14aa0a8d.png";